module.exports = __webpack_public_path__ + "static/media/lendas-colecionaveis_375.6a8116ef.png";